























































































import { Appointment } from '@/shared/appointments/appointment';
import { AppointmentOutcome } from '@/shared/appointments/appointment-outcome';
import { AppointmentCancellationType } from '@/shared/types/appointment-cancellation-type';
import { AppointmentExecutorType } from '@/shared/types/appointment-executor-type';
import { AppointmentOutcomeType } from '@/shared/types/appointment-outcome-type';
import { AppointmentType } from '@/shared/types/appointment-type';
import { formatDate } from '@/shared/utilities/date-utilities';
import { DateTime } from 'luxon';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');

@Component
export default class AppointmentOutcomeDetails extends Vue {
    @typesModule.Getter('activeAppointmentTypes') private appointmentTypes!: Array<AppointmentType>;
    @typesModule.Getter('activeAppointmentOutcomeTypes') private appointmentOutcomeTypes!: Array<AppointmentOutcomeType>;
    @typesModule.Getter('activeAppointmentCancellationTypes') private appointmentCancellationTypes!: Array<AppointmentCancellationType>;
    @typesModule.Getter('activeAppointmentExecutorTypes') private appointmentExecutorTypes!: Array<AppointmentExecutorType>;

    @Prop({ required: true }) private appointment!: Appointment;
    @Prop({ required: true }) private appointmentOutcome!: AppointmentOutcome;
    @Prop({ required: false, default: false }) private isEdit!: boolean;

    private scheduleCallback: boolean = this.appointmentOutcome.callbackDate != null;
    private callbackDate: string | Date | null = this.appointmentOutcome.callbackDate != null ? formatDate(this.appointmentOutcome.callbackDate) : null;
    private callbackHour: number | null = this.appointmentOutcome.callbackDate != null ? formatDate(this.appointmentOutcome.callbackDate)!.getHours() : null;
    private callbackMinute: number | null = this.appointmentOutcome.callbackDate != null ? formatDate(this.appointmentOutcome.callbackDate)!.getMinutes() : null;
    private callbackMeridian: string = this.appointmentOutcome.callbackDate != null ? (formatDate(this.appointmentOutcome.callbackDate)!.getHours() >= 12 ? 'PM' : 'AM') : 'AM';
    private useTwentyFourHours: boolean = false;

    private get appointmentIsInitial(): boolean {
        if (this.appointment.appointmentTypeId == null) {
            return false;
        }

        const appointmentType = this.appointmentTypes.find((type) => type.id === this.appointment.appointmentTypeId);
        return appointmentType == null ? false : appointmentType.isInitialAppointment;
    }

    private get outcomeIsSat(): boolean {
        if (this.appointmentOutcome.outcomeTypeId == null) {
            return false;
        }

        const appointmentOutcomeType = this.appointmentOutcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId);
        return appointmentOutcomeType == null ? false : appointmentOutcomeType.isSat;
    }

    private get outcomeIsNotSat(): boolean {
        if (this.appointmentOutcome.outcomeTypeId == null) {
            return false;
        }

        const appointmentOutcomeType = this.appointmentOutcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId);
        return appointmentOutcomeType == null ? false : appointmentOutcomeType.isNotSat;
    }

    private get outcomeIsCancelled(): boolean {
        if (this.appointmentOutcome.outcomeTypeId == null) {
            return false;
        }

        const appointmentOutcomeType = this.appointmentOutcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId);
        return appointmentOutcomeType == null ? false : appointmentOutcomeType.isCancelled;
    }

    private get hours(): Array<{ value: number, label: string }> {
        const result: Array<{ value: number, label: string }> = [];

        for (let i = 0; i < (this.useTwentyFourHours ? 24 : 12); i++) {
            let value: number = i;
            let label: string = value.toString();

            if (!this.useTwentyFourHours) {
                value = i + 1;
                label = value.toString();

                if (this.callbackMeridian === 'AM') {
                    if (value === 12) {
                        value = 0;
                    }
                } else {
                    if (value !== 12) {
                        value += 12;
                    }
                }
            }

            result.push({ value, label: label.padStart(2, '0') });
        }

        return result;
    }

    private get minutes(): Array<{ value: number, label: string }> {
        return [
            { value: 0, label: '00' },
            { value: 15, label: '15' },
            { value: 30, label: '30' },
            { value: 45, label: '45' },
        ];
    }

    @Watch('scheduleCallback')
    private onScheduleCallbackChanged(): void {
        this.setCallbackDate();
    }

    @Watch('callbackDate')
    private onCallbackDateChanged(): void {
        this.setCallbackDate();
    }

    @Watch('callbackHour')
    private onCallbackHourChanged(): void {
        this.setCallbackDate();
    }

    @Watch('callbackMinute')
    private onCallbackMinuteChanged(): void {
        this.setCallbackDate();
    }

    private setCallbackDate(): void {
        if (!this.scheduleCallback || this.callbackDate == null) {
            this.appointmentOutcome.callbackDate = null;
            return;
        }

        this.appointmentOutcome.callbackDate = (this.callbackDate instanceof Date ? DateTime.fromJSDate(this.callbackDate) : DateTime.fromISO(this.callbackDate))
            .set({
                hour: this.callbackHour == null ? 0 : this.callbackHour,
                minute: this.callbackMinute == null ? 0 : this.callbackMinute,
            })
            .toJSDate();
    }

    @Watch('useTwentyFourHours')
    private onUseTwentyFourHoursChanged(): void {
        if (this.callbackHour == null) {
            return;
        }

        this.callbackMeridian = this.callbackHour >= 12 ? 'PM' : 'AM';
    }

    private onCallbackMeridianChanged(value: string | null): void {
        if (this.callbackHour == null) {
            return;
        }

        if (value === 'AM') {
            this.callbackHour = this.callbackHour === 12 ? 0 : this.callbackHour - 12;
        } else {
            this.callbackHour = this.callbackHour === 0 ? 12 : this.callbackHour + 12;
        }
    }
}
